// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--Q0elY","tableModule":"tableModule--d0Vq4","specialTable":"specialTable--Nqhq0","markerAnimationScale":"markerAnimationScale--kRyXe"};